import type { NodeId } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { selectNodesStableData } from 'components/Graph/model/selectors/selectNodesStableData';
import { makeMemoizedGetNestedObjectKeys } from 'utils/memoize/makeMemoizedGetObjectKeys';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectNodeIds: (s: GraphState) => NodeId[] = createScopedSelector(
  () =>
    makeMemoizedGetNestedObjectKeys(selectNodesStableData) as (
      s: GraphState,
    ) => NodeId[],
);
